import { kebabCase } from 'lodash-es';

export const setAppTheme = (theme: object) => {
  Object.entries(flatObject(theme)).forEach(([key, value]) => {
    setCssRootVariables(key, String(value));
  });
};

const setCssRootVariables = (name: string, value: string) => {
  const root = document.documentElement;

  if (value.startsWith('palette')) {
    value = `var(--${value})`;
  }

  root.style.setProperty(`--${name}`, value);
};

// dive into object keys and combine them with kebap case till value
const flatObject = (obj: object, parentKey = '') => {
  const flattened = {};

  Object.keys(obj).forEach((key) => {
    const fullKey = kebabCase(parentKey ? `${parentKey}-${key}` : key);

    if (typeof obj[key] === 'object') {
      Object.assign(flattened, flatObject(obj[key], fullKey));
    } else {
      flattened[fullKey] = obj[key];
    }
  });

  return flattened;
};
